export default __webpack_public_path__ + "static/leg_img_2-26c1b4bc56167073b16f14977e68122a.png";